import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import api from "../../services/api";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function AspirantsParEgliseChart() {
  const [labels, setLabels] = useState([]);
  const [dataCG, setDataCG] = useState([]);
  const [dataSYL, setDataSYL] = useState([]);

  useEffect(() => {
    api
      .get("/stats/aspirants-par-eglise")
      .then((res) => {
        console.log(" Données reçues depuis l'API :", res.data);
        setLabels(res.data.map((row) => row.eglise));
        setDataCG(res.data.map((row) => row.total_CG));
        setDataSYL(res.data.map((row) => row.total_SYL));
      })
      .catch((err) => {
        console.error("Erreur chargement stats aspirants par église :", err);
      });
  }, []);

  const data = {
    labels,
    datasets: [
      {
        label: "Chef Guide",
        data: dataCG,
        backgroundColor: "#0d6efd"
      },
      {
        label: "SYL",
        data: dataSYL,
        backgroundColor: "brown"
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Répartition des aspirants par Église" }
    }
  };

  return (
    <div className="card shadow-sm mt-4">
      <div className="card-header bg-primary text-white">
        Répartition des aspirants (CG / SYL) par église
      </div>
      <div className="card-body">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}
